import { i, s, x } from '../../lit-element.js';
import { F as FsIcon, f as fs24ChevronLeft } from '../../icon-sprites.js';
import '../../query-assigned-elements.js';
import '../../directive.js';
import '../../unsafe-html.js';

const style = i`
  :host {
    display: block;
    padding-left: 1rem;
    padding-top: 0.5rem;
  }

  :host([hidden]) {
    display: none;
  }

  a {
    cursor: pointer;
  }

  fs-icon {
    color: black;
  }
`;

class RefiBackButton extends s {
  static get styles() {
    return [style];
  }

  constructor() {
    super();
    FsIcon.add(fs24ChevronLeft);
  }

  render() {
    return x`
      <a href="#" aria-label="back button" class="refi-common-back" @click="${this.emitBackBtnEvent}" data-track="back button clicked">
        <fs-icon icon="fs-24-chevron-left" description="Back button"></fs-icon>
      </a>
    `;
  }

  emitBackBtnEvent(ev) {
    ev.preventDefault();
    this.dispatchEvent(new CustomEvent('back-button-click'));
  }
}

export { RefiBackButton };
